const uuid = () => (Math.random() * 4e16).toString(36);

export default uuid;
